import { useTranslation } from 'react-i18next'

import { formatDateTime } from '@/lib/datetime'

import { useAdminContext } from '../session'

type Money = (minor: number | null | undefined) => string

/**
 * Le règlement à l'entrée, sur la fiche : ce qui reste dû et comment la porte
 * l'encaissera, ou — une fois fait — le moyen, l'heure et la personne.
 */
export function AtDoorSettlement({
  pending,
  paysAtDoor,
  dueMinor,
  settledAtDoor,
  method,
  by,
  paidAt,
  money,
}: {
  pending: boolean
  paysAtDoor: boolean
  dueMinor: number | null | undefined
  settledAtDoor: boolean
  method: string | null | undefined
  by: string | null | undefined
  paidAt: string | null
  money: Money
}) {
  const { t, i18n } = useTranslation()
  const { event } = useAdminContext()
  if (settledAtDoor) {
    return (
      <p className="mt-3 rounded-md border border-state-success/40 bg-state-success/5 px-3 py-2 text-sm text-state-success">
        {t('admin.orders.atDoor.settled', {
          method: method ? t(`admin.orders.methods.${method}`, { defaultValue: method }) : '—',
          date: paidAt ? formatDateTime(paidAt, i18n.language, event?.timezone ?? 'UTC') : '—',
          who: by ?? '—',
        })}
      </p>
    )
  }
  if (!paysAtDoor || !pending) return null
  return (
    <div className="mt-3 rounded-md border border-ember-400/40 bg-ember-400/5 px-3 py-2 text-sm">
      <p className="font-medium text-ember-300">
        {dueMinor === null || dueMinor === undefined
          ? t('admin.orders.atDoor.due')
          : t('admin.orders.atDoor.dueAmount', { amount: money(dueMinor) })}
      </p>
      <p className="mt-0.5 text-caption text-content-muted">{t('admin.orders.atDoor.hint')}</p>
    </div>
  )
}
